import { isAfter, isBefore, isSameDay, isValid } from 'date-fns';

const months = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
};

export const formatCycleDate = (d) => {
    d = d.split('-');
    const date = new Date(d[0], parseInt(d[1]) - 1, d[2]);
    const year = date.getFullYear();
    const month = `month.${months[date.getMonth()]}`;

    return { month, year };
};

export const validateDate = (date, minDate, maxDate) => {
    if (isInvalidDateRange(minDate, maxDate)) {
        throw new Error('invalid min or max date');
    }

    if (!date) {
        return 'noDate';
    }

    if (!isValid(date)) {
        return 'invalidDate';
    }

    if (!isSameDay(date, minDate) && isBefore(date, minDate)) {
        return 'minDate';
    }

    if (!isSameDay(date, maxDate) && isAfter(date, maxDate)) {
        return 'maxDate';
    }
};

export const isInvalidDateRange = (startDate, endDate) => {
    if (!isValid(startDate) || !isValid(endDate)) {
        return true;
    }

    if (isSameDay(startDate, endDate)) {
        return false;
    }

    return isAfter(startDate, endDate);
};
